module.exports = __webpack_public_path__ + "static/media/config.3f380419.svg";